import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=61e8f57c&scoped=true&"
import script from "./AboutComponent.vue?vue&type=script&lang=js&"
export * from "./AboutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8f57c",
  null
  
)

export default component.exports